module.exports = __webpack_public_path__ + "static/media/vint.e0405b1d.jpg";